import script from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=15527578&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15527578"]])

export default __exports__